import { createLanguageStore, type LanguageStorage } from '@tupai/i18n/react';
import { parentResources } from '@tupai/i18n/parent';
import type { i18n as I18nInstance } from 'i18next';

export type { AppLocale } from '@tupai/i18n';

// Types `t()` against parent-client's messages only.
declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'common';
    resources: typeof parentResources.en;
    strictKeyChecks: true;
    parseInterpolation: 'icu';
  }
}

// Most tests run without a DOM, so there is no localStorage there.
const memory = new Map<string, string>();
const storage: LanguageStorage =
  typeof localStorage === 'undefined'
    ? { getItem: (k) => memory.get(k) ?? null, setItem: (k, v) => void memory.set(k, v) }
    : localStorage;

const store = createLanguageStore(storage, parentResources);

// For code outside React (stores, formatters, PDF builders): i18n.getFixedT(lang, ns).
export const i18n: I18nInstance = store.i18n;

// Screen readers pick their voice from <html lang>.
function syncHtmlLang(lng: string) {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
}
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export const {
  getLanguage,
  setLanguage,
  hydrateLanguageFromServer,
  hasStoredLanguage,
  useLanguage,
} = store;
